import axios from 'axios'
import { auth, rei } from '@/services/api'
import store from "@/store"

const defaultOptions = {
  loginUrl: '/login',
  proxyUrl: '/configurar-proxy',
  acessarCartorioUrl: '/acessar-cartorio'
}

class AuthInterceptor {
  constructor (options) {
    this.options = {
      ...defaultOptions,
      ...options
    }

    this.configRequest()
    this.configResponse()
  }

  configRequest () {
    const onRequestSend = config => {
      const token = store.getters['auth/getUserToken']
      const tokenIDRC = store.getters['auth/getTokenIDRC']

      // É uma requisição externa, não passamos o token
      // if (config.url.match(/https?/)) {
      //   return config
      // }

      if (token) {
        config.headers.common['authorization'] = `Bearer ${token}`
        config.headers.common['tokenidrc'] = `Bearer ${tokenIDRC}`
        config.headers.common['cartorioid'] = store.getters['auth/getCartorioId']
      }

      return config
    }

    auth.interceptors.request.use(onRequestSend)
    rei.interceptors.request.use(onRequestSend)
    axios.interceptors.request.use(onRequestSend)
  }

  configResponse () {
    const onSuccess = response => response

    const onError = error => {
      const msgs = [
        'E_JWT_TOKEN_EXPIRED: The jwt token has been expired. Generate a new one to continue',
        'E_INVALID_JWT_TOKEN: invalid signature',
        'E_INVALID_JWT_TOKEN: jwt must be provided',
        'token_idrc_not_found'
      ]

      let invalidError, invalidErrorMessage, invalidMessage, invalidMessageError

      if (error.response && error.response.data) {
        invalidError = error.response.data.error && msgs.includes(error.response.data.error)
        invalidErrorMessage = error.response.data.error && msgs.includes(error.response.data.error.message)
        invalidMessage = error.response.data.message && msgs.includes(error.response.data.message)
        invalidMessageError = error.response.data.message && error.response.data.message.error && msgs.includes(error.response.data.message.error.message)
      }

      if (invalidError || invalidErrorMessage || invalidMessage || invalidMessageError) {
        // Removendo token
        store.dispatch('auth/logout')

        const path = window.location.pathname

        if (!Object.values(defaultOptions).includes(path) && path != '/') {
          store.dispatch('auth/setLastPath', path)
        }

        this.options.router.push({ path: this.options.loginUrl })

        setTimeout(() => {
          displayMessage('error', 'Login expirado!', 'Para continuar faça login novamente.').then(() => {
            location.reload()
          })
        })
      }

      return Promise.reject(error)
    }

    auth.interceptors.response.use(onSuccess, onError)
    rei.interceptors.response.use(onSuccess, onError)
    axios.interceptors.response.use(onSuccess, onError)
  }

  static install (Vue, options) {
    /* eslint-disable no-new */
    new AuthInterceptor(options)
  }
}

export default AuthInterceptor
